<template>
    <base-dashboard-view>
        <h2>{{ siteTitle }}</h2>
        <home-wrapper />
    </base-dashboard-view>
</template>

<script>
import dashboardTitle from '@/mixins/dashboardTitle';
import HomeWrapper from '@/components/Dashboard/Home/HomeWrapper';

export default {
    components: {
        HomeWrapper,
    },

    mixins: [dashboardTitle],
};
</script>
